module.exports = __webpack_public_path__ + "0be582c0af1b486f2f816e3df79bf4ff.pdf";